import { render, staticRenderFns } from "./BrokenApiAlert.vue?vue&type=template&id=62e244c9"
import script from "./BrokenApiAlert.vue?vue&type=script&lang=js"
export * from "./BrokenApiAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports